import { render } from "./SkuModal.vue?vue&type=template&id=8677d6c2"
import script from "./SkuModal.vue?vue&type=script&lang=js"
export * from "./SkuModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\WillTerfansky\\Desktop\\Code Files\\Fiverr\\Vue App Solo\\vue-app-rebuild-firebase\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__